export function TableIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
    >
      <path d="M3 3h18v18H3zM21 9H3M21 15H3M12 3v18" />
    </svg>
  )
}
